import { useLoader } from '@react-three/fiber';
import { useLayoutEffect, useMemo } from 'react';
import { GLTFLoader } from 'three-stdlib';

import { isMesh } from 'lib/r3f';

type Props = {
  src: string;
  castShadow?: boolean;
  receiveShadow?: boolean;
} & Omit<React.JSX.IntrinsicElements['primitive'], 'object'>;

export const Model = ({ src, castShadow, receiveShadow, ...props }: Props) => {
  const { scene } = useLoader(GLTFLoader, src);
  const copiedScene = useMemo(() => scene.clone(), [scene]);

  useLayoutEffect(() => {
    if (castShadow !== undefined || receiveShadow !== undefined) {
      copiedScene.traverse(mesh => {
        if (!isMesh(mesh)) {
          return;
        }
        if (castShadow !== undefined) {
          mesh.castShadow = castShadow;
        }
        if (receiveShadow !== undefined) {
          mesh.receiveShadow = receiveShadow;
        }
      });
    }
  }, [copiedScene, castShadow, receiveShadow]);

  return <primitive object={copiedScene} {...props} />;
};
